import { isNative } from './platform'

export async function openExternalLink(url: string) {
  if (isNative) {
    const { Browser } = await import('@capacitor/browser')
    await Browser.open({
      url,
      presentationStyle: 'popover',
      toolbarColor: '#dc2626',
    })
    return
  }

  // Web fallback: open in new tab
  window.open(url, '_blank', 'noopener,noreferrer')
}
